import React from "react"
import { connect } from "react-redux"
import { browserHistory } from "react-router"
import DocumentTitle from "react-document-title"
// app
import NewPerson from "components/person/NewPerson"
import { post } from "actions/profiles/actions.js"


class NewProfile extends React.Component {
    constructor(props) {
        super()

        this.save = this.save.bind(this)
    }

    save(person) {
        this.props.postPerson(person)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== 0)
            browserHistory.replace(`/profiles/${nextProps.id}`)
    }

    render() {
        return <DocumentTitle title="New Profile">
                <div className="page">
                    <div className="row">
                        <div className="col-xs-12">
                            <NewPerson
                                onSave={ this.save }
                            />
                        </div>
                    </div>
                </div>
            </DocumentTitle>
    }
}

function mapDispatchToProps(dispatch) {
    return {
        postPerson: (person) => dispatch(post(person))
    }
}

function mapStateToProps(state) {
    return {
        id: state.profiles.get("id", 0)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewProfile)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/New/new-profile.js
 **/